import httpMethod from 'services/update2025/httpMethod';
import Parser from "html-react-parser";

import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { NotificationLogContext } from "./NotificationLogContext";
import { Editor } from "primereact/editor";

export const NotificationLogEditor = () => {
    const toast = useRef(null);
    const { t, i18n } = useTranslation(["notification-log", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const statuses = [
        { label: "Gửi thành công", value: "SENT_SUCCESS" },
        { label: "Gửi thất bại", value: "SENT_FAILURE" },
    ];

    const notificationLogContext = useContext(NotificationLogContext);
    const { notificationLog, resetNotificationLog, setNotificationLog, notificationLogs, setNotificationLogs, submitted, setSubmitted, notificationLogDialog, setNotificationLogDialog } = notificationLogContext;

    const hideDialog = () => {
        setNotificationLogDialog(false);
    };

    const formatDateInput = (data) => {
        if (data) {
            const year = data?.substr(0, 4);
            const month = data?.substr(5, 2);
            const day = data?.substr(8, 2);
            const hour = data?.substr(11, 2);
            const minute = data?.substr(14, 2);
            const second = data?.substr(17, 2);

            return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
        }
        return null;
    };

    const unescapeHTML = (html) => {
        var escapeEl = document.createElement("textarea");
        escapeEl.innerHTML = html;
        return escapeEl.textContent;
    };

    return (
        <>
            <Toast ref={toast} />
            <Dialog visible={notificationLogDialog} style={{ width: "70%" }} header={t("notification-log.titleDetail")?.toUpperCase()} modal className="p-fluid text-center" onHide={hideDialog}>
                <div className="formgrid">
                    <div className="grid text-left">
                        <div className="col-12">
                            <div className="grid">
                                {/* tên đăng nhập */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="userName">{t("notification-log.userName")}</label>
                                    <InputText name="userName" id="userName" value={notificationLog.userName} readOnly={true} />
                                </div>

                                {/* trạng thái */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="status">{t("notification-log.status")}</label>
                                    <InputText name="status" id="status" value={statuses.find((e) => e.value === notificationLog?.status)?.label} readOnly={true} />
                                </div>

                                {/* ngày gửi*/}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="createdDate">{t("notification-log.createdDate")}</label>
                                    <InputText name="createdDate" id="createdDate" value={formatDateInput(notificationLog.createdDate)} readOnly={true} />
                                </div>

                                {/* thiết bị */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="updatedDate">{t("notification-log.updatedDate")}</label>
                                    <InputText name="updatedDate" id="updatedDate" value={formatDateInput(notificationLog.updatedDate)} readOnly={true} />
                                </div>
                            </div>

                            <div className="grid">
                                {/* nội dung */}
                                <div className="field col-12 md:col-12">
                                    {/* <div className="grid"> */}
                                    {/* <div className="col-12"> */}
                                    <label htmlFor="content">{t("notification-log.content")}</label>
                                    {/* </div>
                                        <div className="col-12" style={{ border: "1px solid #ced4da" }}>
                                            {notificationLog.content ? Parser(notificationLog.content) : null}
                                        </div>
                                    </div> */}

                                    <Editor id="content" showHeader={false} style={{ height: "100px" }} value={notificationLog.content} readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="grid">
                    <div className="col-12">
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </Dialog>
        </>
    );
};
